export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

/** The address printed in the blocked line and the help copy (PD-0054); override per environment. */
export const SUPPORT_EMAIL: string = import.meta.env.VITE_SUPPORT_EMAIL || "support@timeplanned.com";